module.exports = __webpack_public_path__ + "static/media/faqBalance-en-ru.96616148.vtt";